import React, { useEffect, useState } from "react";
import "../css/App.css";
import HorizontalSplitIcon from "@material-ui/icons/HorizontalSplit";
import GitHubIcon from "@material-ui/icons/GitHub";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import { InView } from "react-intersection-observer";
import { useSpring, animated } from "react-spring";

export default function Footer() {
  const [showH2, setShowH2] = useState(false);

  useEffect(() => {
    setShowH2(false);
  }, []);

  function scrollUp() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }

  var InViewChange = (inview) => {
    console.log("CALLED", showH2);
    if (!showH2 && inview) setShowH2(true);
  };

  const props = useSpring({
    width: "25vw",
    from: { opacity: 0, marginLeft: showH2 ? -200 : 0 },
    to: { opacity: showH2 ? 1 : 0, marginLeft: 0 },
    config: { mass: 25, tension: 260, friction: 100 },
  });

  return (
    <div
      className="d-flex"
      style={{
        flexDirection: "column",
        height: "100vh",
        width: "100vw",
        overflowX: "hidden",
      }}
    >
      <InView onChange={InViewChange}>
        <div
          style={{ height: "45vh", position: "relative", width: "100vw" }}
          className="svgElem"
        >
          <animated.div style={props}>
            <div id="dd">
              <h1 className="fw-bold absCenter" style={{}}>
                CONTACT
              </h1>
              <h3
                className="highText centerText mt-5 absCenter gFont"
                id="workT"
                style={{ top: "55%" }}
              >
                Would you like to work with me? Awesome!
              </h3>
              <button
                id="talk"
                className="absCenter btn btn-background-slide "
                style={{ top: "85%" }}
                onClick={(e) => {
                  window.location = "mailto:neeleshwark17@gmail.com";
                  e.preventDefault();
                }}
              >
                <strong className="strong">Let's Talk</strong>
              </button>
            </div>
          </animated.div>

          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
            <path
              fill="white"
              fillOpacity="1"
              d="M0,192L1440,32L1440,0L0,0Z"
            ></path>
          </svg>
        </div>
      </InView>

      <div
        className="container-fluid footerBackground"
        style={{ height: "55vh" }}
      >
        <div
          className="d-flex flex-column align-items-center"
          style={{ height: "80%" }}
        >
          <div onClick={scrollUp}>
            <ExpandLessIcon
              className="icon mt-3"
              style={{ width: "40px", height: "40px", cursor: "pointer" }}
            />
          </div>
          <p
            className="m-3 fs-5 d-flex justify-content-center gFont"
            id="frame"
            style={{
              color: "white",
            }}
          >
            Mostly Used frameworks and language
          </p>

          <div
            className="d-flex flex-column justify-align-content-center align-align-items-center"
            id="footerIcons"
          >
            <div className="d-flex justify-content-center">
              <img
                src="css.png"
                alt=""
                style={{ objectFit: "contain", width: "60px" }}
              />
              <img
                src="html.png"
                alt=""
                style={{ objectFit: "contain", width: "60px" }}
              />
              <img
                src="js.png"
                alt=""
                style={{ objectFit: "contain", width: "60px" }}
              />
              <img
                src="java.png"
                alt=""
                style={{ objectFit: "contain", width: "60px" }}
              />
            </div>
            <div className="d-flex justify-content-center">
              <img
                src="nodejs.png"
                alt=""
                style={{ objectFit: "contain", width: "60px" }}
              />
              <img
                src="react.png"
                alt=""
                style={{ objectFit: "contain", width: "60px" }}
              />
              <img
                src="android.png"
                alt=""
                style={{ objectFit: "contain", width: "60px" }}
              />
              <img
                src="flutter.png"
                alt=""
                style={{ objectFit: "contain", width: "60px" }}
              />
            </div>
            <p
              className="m-3 fs-5 d-flex justify-content-center gFont"
              id="socialLinks"
              style={{
                color: "white",
              }}
            >
              -- Social links --
            </p>
            <p
              className="m-0  d-flex justify-content-center "
              style={{
                color: "white",
              }}
            >
              <span id="infos" className="fs-6 m-2">
                neeleshwark17@gmail.com
              </span>
              <span id="infos" className="fs-6 mt-2 me-2 mb-2">
                +91 7626856418
              </span>
            </p>
          </div>
        </div>

        <div className="container d-flex justify-content-center">
          <div
            className="iconButton  me-4"
            onClick={() => {
              window.open("https://github.com/neeleshwark17", "_blank");
            }}
          >
            <GitHubIcon className="icon" />
          </div>
          <div
            className="iconButton ms-4"
            onClick={() => {
              window.open(
                "https://stackoverflow.com/users/11753476/neeleshwar-kumar",
                "_blank"
              );
            }}
          >
            <HorizontalSplitIcon className="icon" />
          </div>
        </div>
        <center>
          <div className="line"></div>
        </center>
      </div>
    </div>
  );
}
